import { Component, ChangeDetectionStrategy, Inject } from '@angular/core';

import * as Tokens from '@shared/core/tokens';
import { Controllers } from '@shared/core/controllers';

import { AuthTypeComponent } from '../auth-type.shared.component';

@Component({
    selector: 'shared-auth-for-rewards-account-linking-info',
    templateUrl: './auth-for-rewards-account-linking-info.shared.component.html',
    styleUrls: ['./auth-for-rewards-account-linking-info.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthForRewardsAccountLinkingInfoComponent extends AuthTypeComponent {
    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
        public controllers: Controllers,
    ) {
        super(controllers);
    }

    public get description(): string {
        return this.config.signUpRewardsAccountLinking?.introText || null;
    }

    public handleLinkRewardsAccountClick($event: Event): void {
        this.controllers.members.setLinkRewardsAccountStep();
    }

    public handleCreateNewProfileClick($event: Event): void {
        this.controllers.members.setSignUpStep();
    }
}
